import { API_RECID_MAP, API_EVENT_MAP } from "./const";

/** @desc 通过eventId 获取 RecId */
export const getRecId = (eventId) => {
  const api = API_EVENT_MAP[eventId] || '';
  return API_RECID_MAP[api] || ''
}
